import { NormalizedListingTypes } from '../../../api-client/enums'
import DownArrow from '../../../components/svg/down-arrow'

export default function ListingTypeFilterHandle({ listingType, name, onClick }) {
  return (
    <>
      <button
        aria-label='Set listing type'
        className='flatBtn handle'
        onClick={() => onClick(name)}
      >
        <span className='label'>Type</span>
        <span>
          {Object.keys(listingType)
            .map((id) => NormalizedListingTypes[id])
            .join(', ')}
        </span>
        <DownArrow className='arrowSvg' />
      </button>

      <style jsx>{`
        .handle {
          position: relative;
          width: auto;
          padding: 0 2rem;
          color: var(--primary-color);
          font-weight: 700;
          font-size: 1.8rem;

          .label {
            margin: 0 1.3rem 0 0;
            color: var(--primary-bg-color);
          }

          :global(.arrowSvg) {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(0, -50%);
            width: 1.2rem;
            height: 0.6rem;
          }
        }

        @media (max-width: 1024px) {
          .handle {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </>
  )
}
